import { useMemo } from "react";

import { BlankContentForList } from "@/components/features/_components";

import { Table, TableBody } from "@/components/ui/table/table";

import { AboutForSearchResultTable } from "./about-for-search-result-table";
import { SearchResultTableTBody } from "./body";
import { SearchResultTableTHead } from "./t-head";

import type { ViewData } from "../../../model/type";

type Props = {
	// 行データ
	viewData: ViewData;
};

export const SearchResultTable = ({ viewData }: Props) => {
	const { rows } = viewData.searchResultTableData;

	/**
	 * 行データの表示制御
	 */
	const canShowRows = useMemo(() => rows.length > 0, [rows.length]);

	return (
		<>
			{canShowRows ? (
				<div className="space-y-4">
					<AboutForSearchResultTable viewData={viewData} />
					<div className="max-h-96 overflow-y-scroll shadow-sm sm:max-h-full">
						<Table id="search-result-table" className="w-full min-w-[max-content]">
							{/* ヘッダー */}
							<SearchResultTableTHead />

							{/* 行 */}
							<TableBody className="relative">
								<>
									{rows.map((row, index) => (
										<SearchResultTableTBody key={index} row={row} />
									))}
								</>
							</TableBody>
						</Table>
					</div>
				</div>
			) : (
				<BlankContentForList content={`該当のデータがありません。\n条件を変更して検索してください。`} />
			)}
		</>
	);
};
